import * as React from "react";
import { Row } from "antd";
import { ColumnProps } from "antd/lib/table";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { dayjs } from "Config/dayjs";
import { Button } from "Components/General/Button";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { fileDetailsStore } from "../FileDetailsStore";
import { observer } from "mobx-react";
import { download } from "utils/download";
import { Table } from "Components/General/Table";

interface LogSummaryProps extends WithTranslation {}

interface LogSummaryState {
  data: API_FileLogEntry[];
  loading: boolean;
}

export const LogSummary = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<LogSummaryProps, LogSummaryState> {
      constructor(props: LogSummaryProps) {
        super(props);

        this.state = {
          data: [],
          loading: false,
        };
      }

      componentDidMount() {
        (async () => await this.handleFetch())();
      }

      handleFetch = async () => {
        try {
          this.setState({ loading: true });
          const response: API_FileLogEntry[] = await API.getData(
            API_URL.FILES.getFileLog(projectsDataStore.projectId, fileDetailsStore.fileId)
          );
          this.setState({ data: response });
        } catch (error) {
          throw error;
        } finally {
          this.setState({ loading: false });
        }
      };

      exportExcel = async () => {
        try {
          const file: File = await API.getBlob(
            API_URL.FILES.getExcelFileLog(projectsDataStore.projectId, fileDetailsStore.fileId)
          );
          download(file, file.name, file.type);
        } catch (error) {
          throw error;
        }
      };

      render() {
        const { data, loading } = this.state;
        const { t } = this.props;

        const columns: ColumnProps<API_FileLogEntry>[] = [
          {
            dataIndex: "timestamp",
            title: t("Date"),
            render: (text) => <div style={{ width: 180 }}>{dayjs(+text).format("lll")}</div>,
            width: 180,
          },
          {
            dataIndex: "userName",
            title: t("User"),
            width: 180,
            render: (text, record) => record.userName,
          },
          {
            dataIndex: "type",
            title: t("Type"),
            width: 150,
          },
          {
            dataIndex: "action",
            title: t("Action"),
          },
          {
            dataIndex: "description",
            title: t("Message"),
          },
        ];

        return (
          <>
            <Row className="mb-2" justify="end">
              <Button faIcon={["far", "file-excel"]} type="primary" onClick={this.exportExcel}>
                {t("Export as Excel")}
              </Button>
            </Row>
            <Table<API_FileLogEntry>
              name="logSummary"
              rowKey="timestamp"
              dataSource={data}
              loading={loading}
              columns={columns}
              scroll={{ x: 900 }}
            />
          </>
        );
      }
    }
  )
);
